import { useUser } from "@/context/UserContext";
import { useRouter } from "next/router";
import Link from "next/link";
import { FaChalkboardTeacher } from "react-icons/fa";

const Category = () => {
  const { user } = useUser();
  const router = useRouter();

  if (user?.role === "instructor") return null;

  const shouldHide = 
    router.pathname.startsWith("/login") || 
    router.pathname.startsWith("/register") || 
    router.pathname === "/become-a-teacher" ||
    router.pathname.startsWith("/hr-admin");

  return (
    <div className="rbt-category-menu-wrapper rbt-category-update">
      {/* {shouldHide ? (
        <div className="rbt-category-btn" style={{ visibility: 'hidden' }}>
          <div className="rbt-offcanvas-trigger md-size icon">
            <span className="d-none d-xl-block">
              <FaChalkboardTeacher />
            </span>
          </div>
          <span className="category-text d-none d-xl-block">
            Become an Instructor?
          </span>
        </div>
      ) : (
        <Link href="/become-a-teacher" passHref>
          <div className="rbt-category-btn cursor-pointer">
            <div className="rbt-offcanvas-trigger md-size icon">
              <span className="d-none d-xl-block">
                <FaChalkboardTeacher />
              </span>
            </div>
            <span className="category-text d-none d-xl-block">
              Become an Instructor?
            </span>
          </div>
        </Link>
      )} */}
    </div>
  );
};

export default Category;